export default function swDev() {

    try{
        let swUrl = `${process.env.PUBLIC_URL}/sw.js`
        navigator?.serviceWorker?.register(swUrl)?.then(response => {
        })
    } catch(err) {
         console.log('Error :: ',err);
    }
}